import { render, staticRenderFns } from "./Twofactor.vue?vue&type=template&id=5a7cb85b"
import script from "./Twofactor.vue?vue&type=script&lang=js"
export * from "./Twofactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports